import { useEffect, useState } from "react";
import { IGif, INiche } from "@/common/services/types";
import { apiMain, apiNiches } from "@/common/services";
import { Roles } from "@/common/buses/popups/popup-types";

interface IProps {
  gifId: string;
  role: Roles;
}

interface IReturn {
  gif?: IGif;
  niches: INiche[];
  isLoading: boolean;
  isError: boolean;
}

export const useData = ({ gifId, role }: IProps): IReturn => {
  const [gif, setGif] = useState<IGif>();
  const [niches, setNiches] = useState<INiche[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        const response = await apiMain.fetchGifById(gifId);
        setGif(response.gif);
        let niches = response.niches;

        if (role === Roles.moderator) {
          const myNichesData = await apiNiches.getMyNiches();

          const myNicheIds = myNichesData.niches.map((niche) => niche.id);
          niches = niches.filter((niche) => myNicheIds.includes(niche.id));
        }

        setNiches(niches);
      } catch (e) {
        console.error(`Could not get gif niches or niches list: ${e}`);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [gifId, role]);

  return {
    gif,
    niches,
    isLoading,
    isError,
  };
};
